<script setup>
import TimeRegistrationsTable from '@/Pages/PartnerSupport/Tickets/Partials/TimeRegistrationsTable.vue';
import { ref } from 'vue';
import CreateTimeRegistrationModal from '@/Pages/PartnerSupport/Tickets/Partials/CreateTimeRegistrationModal.vue';

const props = defineProps({
  ticket: {
    type: Object,
    required: true,
  },
  timeRegistrations: {
    type: Array,
    required: true,
  },
  filters: {
    type: Object,
    default: () => ({}),
  },
  hasAvailablePaidServices: {
    type: Boolean,
  },
  availableHours: {
    type: String,
  },
});

const isShowTimeRegistrationForm = ref(false);

const showTimeRegistrationForm = () => {
  isShowTimeRegistrationForm.value = true;
};
</script>

<script>
import DashboardLayout from '@/Layouts/DashboardLayout.vue';
import SupportTicketLayout from '@/Layouts/SupportTicketLayout.vue';

export default {
  layout: [DashboardLayout, SupportTicketLayout],
};
</script>

<template>
  <div>
    <div class="tile my-4">
      <div v-if="ticket.paidServiceMinutesInsufficient" class="alert alert-danger">
        {{ trans("__JSON__.Customer's paid services minutes are insufficient.") }}
      </div>
      <div class="flex my-4 justify-content-between">
        <div>
          {{ trans('__JSON__.Available paid services hours') }}:
          <span v-if="hasAvailablePaidServices">{{ availableHours }}</span>
          <span v-else>{{ trans('__JSON__.No available hours') }}</span>
        </div>
        <button v-if="hasAvailablePaidServices" type="button" class="button" @click="showTimeRegistrationForm">
          {{ trans('__JSON__.Log Time Registration') }}
        </button>
      </div>
      <time-registrations-table
        :ticket="ticket"
        :time-registrations="timeRegistrations"
        :hidden-columns="['ticketId']"
      />
    </div>
    <create-time-registration-modal
      :ticket="ticket"
      :show="isShowTimeRegistrationForm"
      @close="isShowTimeRegistrationForm = false"
    />
  </div>
</template>
